import {Http, URLSearchParams} from '@angular/http';
import {Injectable} from '@angular/core';
import {NotificationsService} from 'angular2-notifications';

import DataProvider from './dataProvider.service';
import Broadcaster from '../../../app/services/broadcaster.service';

import {Observable} from "rxjs/Rx";
import CypherService from "../cypher.service";


@Injectable()
class AuthDataProvider extends DataProvider {

    constructor(http: Http,
                Broadcaster: Broadcaster,
                NotificationsService: NotificationsService,
                cypherService: CypherService
    ) {
        super(
            http,
            Broadcaster,
            NotificationsService,
            cypherService
        );
    }

    private uri: string = 'generaluserlogins';


    public login(body = {}): Observable<any> {
        return this.post(`${this.baseUri + this.uri}`, body, {});
    }


}

export default AuthDataProvider;


// WEBPACK FOOTER //
// ./src/app/services/dataProviders/authDataProvider.service.ts